import styled from "styled-components";

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  & > a {
    display: block;
    flex: 1;
  }
`;
